import Vapi from "vuex-rest-api";
import { API_URL } from "../config";
import localforage from "localforage";
import * as THREE from "three";
import "three/examples/js/loaders/GLTFLoader";
import "three/examples/js/loaders/DRACOLoader";

const loader = new THREE.FileLoader();
loader.setResponseType("arraybuffer");

const gltfLoader = new THREE.GLTFLoader();
THREE.DRACOLoader.setDecoderPath("draco/");
gltfLoader.setDRACOLoader(new THREE.DRACOLoader());

const types = new Vapi({
  baseURL: API_URL,
  state: {
    types: []
  }
})
  .get({
    action: "getTypes",
    property: "types",
    path: "/types"
  })
  .getStore();

types.getters = {};
types.getters.sortedTypes = function(state, getters) {
  return state.types.sort((a, b) => {
    if (a.id < b.id) return -1;
    if (b.id < a.id) return 1;
    return 0;
  });
};

types.actions.getModelForType = function({ state }, typeId) {
  return new Promise(resolve => {
    // Get the type
    const type = state.types.find(type => type.id === typeId);
    if (type === undefined) return null;

    const key = type.key + "_model";

    // Check the cache for the given type Id
    localforage
      .getItem(key)
      .then(value => {
        // If a entry exists return it
        if (value !== null) {
          gltfLoader.parse(value, "", gltf => {
            resolve(gltf);
          });
        } else {
          // If not
          //  Load the data from the types url
          loader.load(type.model, data => {
            // Set the cache value
            localforage
              .setItem(key, data)
              .then(_ => {
                // Return the parsed response
                gltfLoader.parse(data, "", gltf => {
                  resolve(gltf);
                });
              })
              .catch(err => {
                console.log(err);
              });
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  });
};

export default types;
